export { fastifyErrorMiddleware } from './handlers/fastify.js'
